import { Card, Space } from "antd";
import { useTranslation } from "react-i18next";
import { SecondaryButton } from "../../../../common/components/buttons/SecondaryButton";
import AntIcon from "../../../../common/components/icons/AntIcon";
import { Permission } from "../../../../common/security/enums";
import ComponentWithPermission from "../../../auth/components/ComponentWithPermission";

interface Props {
  onImportClientsClick: () => void;
  onImportAgentsClick: () => void;
  onImportContractsClick: () => void;
}

export const ContractUpdateFilterView = ({
  onImportClientsClick,
  onImportAgentsClick,
  onImportContractsClick,
}: Props) => {
  const { t } = useTranslation();

  return (
    <Card
      className="card-box"
      title={<h2>{t("contractUpdate.titles.list")}</h2>}
      extra={
        <Space size="small">
          <ComponentWithPermission permissions={[Permission.CLIENT_IMPORT]}>
            <SecondaryButton icon={<AntIcon type="user-add" />} onClick={onImportClientsClick}>
              {t("client.actions.import")}
            </SecondaryButton>
          </ComponentWithPermission>

          <ComponentWithPermission permissions={[Permission.AGENT_IMPORT]}>
            <SecondaryButton icon={<AntIcon type="user-add" />} onClick={onImportAgentsClick}>
              {t("agent.actions.import")}
            </SecondaryButton>
          </ComponentWithPermission>

          <ComponentWithPermission permissions={[Permission.CONTRACT_IMPORT]}>
            <SecondaryButton icon={<AntIcon type="plus-circle" />} onClick={onImportContractsClick}>
              {t("contract.actions.import")}
            </SecondaryButton>
          </ComponentWithPermission>
        </Space>
      }
    />
  );
};
